export enum APIError {
    ALREADY_ACCEPTED = 'ALREADY_ACCEPTED',
    ALREADY_CREATED = 'ALREADY_CREATED',
    ALREADY_LINKED = 'ALREADY_LINKED',
    INVALID_GRANT = 'invalid_grant',
    FILE_NAME_ALREADY_USED = 'FILE_NAME_ALREADY_USED',
    LINKED_WITH_RESOURCE = 'LINKED_WITH_RESOURCE',
    NOT_DEPLOYED = 'NOT_DEPLOYED',
    POINT_MUST_HAVE_DIFFERENT_SOURCES = 'POINT_MUST_HAVE_DIFFERENT_SOURCES',
    SYSTEM_LINKED_WITH_TILE = 'SYSTEM_LINKED_WITH_TILE',
    UNEXISTING_BUILDING = 'UNEXISTING_BUILDING',
    UNEXISTING_INVITATION = 'UNEXISTING_INVITATION',
    UNEXISTING_FILE = 'UNEXISTING_FILE',
    UNEXISTING_INVOICE = 'UNEXISTING_INVOICE',
    UNEXISTING_SENSOR = 'UNEXISTING_SENSOR',
    UNEXISTING_SYSTEM = 'UNEXISTING_SYSTEM',
    UNEXISTING_USER = 'UNEXISTING_USER',
    UNAUTHORIZED = 'UNAUTHORIZED',
    UNAUTHORIZED_FILE_TYPE = 'UNAUTHORIZED_FILE_TYPE',
    WRONG_UNIVERSE = 'WRONG_UNIVERSE',
    DUPLICATE_AXIS_CATEGORY_NAME = 'DUPLICATE::axisName+categoryName',

    // Scenarios
    INVALID_CONFIGURATION = 'INVALID_CONFIGURATION',
    INVALID_THRESHOLD = 'INVALID_THRESHOLD',
    INVALID_DATE_RANGE = 'INVALID_DATE_RANGE',
    ALREADY_USED_NAME = 'ALREADY_USED_NAME',
    EMPTY_PERIMETER = 'EMPTY_PERIMETER',
    ALERT_API_FAILED = 'ALERT_API_FAILED',

    // Login
    PASSWORD_MISMATCH = 'PASSWORD_MISMATCH',
    PASSWORDS_MUST_BE_DIFFERENTS = 'PASSWORDS_MUST_BE_DIFFERENTS',

    //Export
    EXPORT_COOLDOWN = 'EXPORT_COOLDOWN'
}

export enum FrontError {
    EXPORT_TO_BIG = 'EXPORT_TO_BIG',
    MODULE_NOT_SUPPORTED = 'MODULE_NOT_SUPPORTED'
}
